import { type ChangeEvent, type FC } from 'react';

import {
  Pagination,
  PaginationBar,
  PaginationBarLeft,
  PaginationBarRight,
  SelectField,
} from '@wk/components-react16';

interface ApplicationEvaluationsPaginationProps {
  isMobileViewport: boolean;
  totalCount: number;
  page: number;
  pageCount: number;
  limit: number;
  onLimitChange: (limit: number) => void;
  onPageChange: (page: number) => void;
}

const ApplicationEvaluationsPagination: FC<
  ApplicationEvaluationsPaginationProps
> = ({
  isMobileViewport,
  totalCount,
  page,
  pageCount,
  limit,
  onLimitChange,
  onPageChange,
}) => {
  if (isMobileViewport) {
    return (
      <div className="evaluations-pagination-mobile-row">
        <span className="evaluations-pagination-mobile-results">
          {totalCount} results
        </span>
        <span className="evaluations-pagination-mobile-page">
          {page}/{pageCount || 1}
        </span>
        <div className="evaluations-pagination-mobile-limit">
          <SelectField size="small">
            <select
              value={limit}
              onChange={(event: ChangeEvent<HTMLSelectElement>) => {
                onLimitChange(Number(event.target.value));
              }}
            >
              <option value="30">30</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="200">200</option>
            </select>
          </SelectField>
        </div>
        <Pagination
          pageIndex={page}
          pageCount={pageCount}
          onUserRequest={onPageChange}
        />
      </div>
    );
  }

  return (
    <PaginationBar>
      <PaginationBarLeft>{totalCount} results </PaginationBarLeft>
      <PaginationBarRight>
        <div className="flex items-center gap-4">
          <p className="text-sm text-muted-foreground">
            Page {page} of {pageCount}
          </p>
          <SelectField size="small">
            <select
              value={limit}
              onChange={(event: ChangeEvent<HTMLSelectElement>) => {
                onLimitChange(Number(event.target.value));
              }}
            >
              <option value="30">30</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="200">200</option>
            </select>
          </SelectField>
          <Pagination
            pageIndex={page}
            pageCount={pageCount}
            onUserRequest={onPageChange}
          />
        </div>
      </PaginationBarRight>
    </PaginationBar>
  );
};

export default ApplicationEvaluationsPagination;
